/* PyP accesibilidad v1 — etiqueta elementos generados dinámicamente (iconos, botones de tarjeta, cantidad, enlaces). Aditivo y reversible: para desactivar, borra este archivo y la línea <script ...pyp-a11y...> en snippets/header.liquid. */
(function () {
  "use strict";
  function hasName(el) {
    if (!el) return true;
    if (el.getAttribute("aria-label")) return true;
    if (el.getAttribute("aria-labelledby")) return true;
    if (el.getAttribute("title")) return true;
    if ((el.textContent || "").trim()) return true;
    var img = el.querySelector && el.querySelector("img[alt]");
    if (img && (img.getAttribute("alt") || "").trim()) return true;
    return false;
  }
  function label(el, text) {
    if (el && text && !hasName(el)) el.setAttribute("aria-label", text);
  }
  function each(root, sel, fn) {
    var list = (root || document).querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) fn(list[i]);
  }
  function run(root) {
    try {
      each(root, "a.t4s-push-menu-btn", function (a) { label(a, "Abrir menú"); });
      each(root, "a.t4s-pr-wishlist, .t4s-product-form__btn.t4s-pr-wishlist", function (a) { label(a, "Añadir a favoritos"); });
      each(root, "a.t4s-pr-quickview", function (a) { label(a, "Vista rápida"); });
      each(root, "a.t4s-pr-compare, .t4s-product-form__btn.t4s-pr-compare", function (a) { label(a, "Comparar"); });
      each(root, "a.t4s-pr-addtocart", function (a) { label(a, "Agregar al carrito"); });
      each(root, "input.t4s-quantity-input", function (i) { if (!i.getAttribute("aria-label")) i.setAttribute("aria-label", "Cantidad"); });
      each(root, "a.t4s-full-width-link", function (a) {
        if (hasName(a)) return;
        var name = "";
        var card = a.closest ? a.closest(".t4s-product") : null;
        var t = card && card.querySelector(".t4s-product-title");
        if (t) name = (t.textContent || "").trim();
        if (!name) {
          var m = (a.getAttribute("href") || "").match(/\/products\/([^\/?#]+)/);
          if (m) name = decodeURIComponent(m[1]).replace(/[-_]+/g, " ").trim();
        }
        label(a, name || "Ver producto");
      });
      each(root, 'input[type="email"]', function (i) { if (!i.getAttribute("aria-label") && !i.id) i.setAttribute("aria-label", "Correo electrónico"); });
      each(root, "iframe#merchantwidgetiframe", function (f) { if (!f.getAttribute("title")) f.setAttribute("title", "Reseñas de Google"); });
    } catch (e) {}
  }
  function init() {
    run(document);
    if (window.MutationObserver && document.body) {
      var timer, obs = new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { run(document); }, 300);
      });
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, 25000);
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
